import { GraphQLClient } from 'graphql-request';
import SiteSettings from 'src/siteSetting';
import TokenGenerator from 'src/tokenGenerator/graphql';

// TODO: have to add response middle ware to handle errros 

// import { reportException } from './exceptionReporting';
// import { pathOr } from 'ramda';
// import { isNotEmpty } from './utilities/hasValue';

// const responseMiddleware = (response: any) => {
//   const errors = pathOr([], ['errors'],response)
//   if (isNotEmpty(errors)) {
//     reportException(` graphql Error -> ${errors}`);
//   }
// }

export const applicationClient = async () => {
  const hasuraJwtToken = await TokenGenerator.getInstance().getToken();
  const applicationClient = new GraphQLClient(SiteSettings.graphqlAppEndpoint(), {
    headers: {
      Authorization: `Bearer ${hasuraJwtToken}`
    }
  });

  return applicationClient;
};